var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 108,
    viewBox: "0 0 107 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_1855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5047 106.298C24.9052 106.298 1.71094 82.8842 1.71094 54.0043C1.71094 25.1245 24.9052 1.71094 53.5047 1.71094C82.1042 1.71094 105.299 25.1245 105.299 54.0043",
    stroke: "#572580",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.298 54.0039C105.298 54.5742 105.298 55.1217 105.298 55.6464",
    stroke: "#572580",
    strokeWidth: 4,
    strokeDasharray: "3.99 3.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.059 59.0508C102.647 84.4575 82.2321 104.552 56.8398 106.186",
    stroke: "#572580",
    strokeWidth: 4,
    strokeDasharray: "3.99 3.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.146 106.271C54.5758 106.271 54.0285 106.271 53.5039 106.271",
    stroke: "#572580",
    strokeWidth: 4,
    strokeDasharray: "3.99 3.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9667 40.7956L70.8406 30.5645L44.7898 56.8694L36.9728 48.9736L26.8467 59.2048L44.67 77.4343L80.9667 40.7956Z",
    stroke: "#572580",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_1855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 108,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptIcon);
export default __webpack_public_path__ + "static/media/acceptIcon.6ee8a2da4c3b19c06affcdb27a2bc839.svg";
export { ForwardRef as ReactComponent };